module.exports = __webpack_public_path__ + "static/img/Acer_TMP278.d539dca5.png";